import type { Sort, Attributes } from 'stores/PaginationTypes';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

export const EVENT_PROCEDURES_LIL_LIST_ID = 'eventProceduresLilList';

export const ATTRIBUTES: Attributes = [
  {
    id: 'select',
    title: '',
    type: 'BOOLEAN',
    filterable: false,
    sortable: false,
    searchable: false,
  },
  {
    id: 'title',
    title: 'Title',
    type: 'STRING',
    filterable: false,
  },
];

export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_LIL_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
    defaultDisplayedAttributes: ['select', 'title'],
  },
  columnOrder: ['select', 'title'],
};

export const deserializeEventProcedures = ({ page, per_page, total, count, event_procedures }) => ({
  attributes: ATTRIBUTES,
  list: event_procedures.map((procedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => ({
    select: false,
    ...procedure,
  })),
  pagination: { total, page, per_page, count },
});
